import { render, staticRenderFns } from "./visualizar.vue?vue&type=template&id=60ecab0c"
import script from "./visualizar.vue?vue&type=script&lang=js"
export * from "./visualizar.vue?vue&type=script&lang=js"
import style0 from "./visualizar.vue?vue&type=style&index=0&id=60ecab0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports